import { render, staticRenderFns } from "./AssetEditor.vue?vue&type=template&id=3dca2288&scoped=true"
import script from "./AssetEditor.vue?vue&type=script&lang=js"
export * from "./AssetEditor.vue?vue&type=script&lang=js"
import style0 from "./AssetEditor.vue?vue&type=style&index=0&id=3dca2288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca2288",
  null
  
)

export default component.exports